import * as React from 'react';
import RouterComponent from 'RouterComponent';
import {HashRouter} from 'react-router-dom';
import {isWebview} from "utils";
import Header from 'web-com/Header';
import Footer from 'web-com/footer';
import 'assets/style/styles.scss';

function App () {
  return (
    <HashRouter>
      <div className="root-container">
        {!isWebview() && <Header login={{} as any } logout={{} as any}  />}
        <RouterComponent />
        {!isWebview() && <Footer />}
      </div>
    </HashRouter>
  );
}

export default App;